<template>
  <div>
    <b-card-text>
      対象にバリアを付与します。
    </b-card-text>
    <b-form-group id="HP" label="HP"
      label-cols="3">
      <b-form-input type="number" v-model="innerValue.arguments.HP"
        :min="0" :max="99" number />
    </b-form-group>
    <b-form-group id="HP" label="吸収値"
      description="ダメージの (吸収値)/10 %をバリアが受けます。"
      label-cols="3">
      <b-form-input type="number" v-model="innerValue.arguments.Buffer"
        :min="0" :max="1000" number />
    </b-form-group>
    <b-card title="異常状態">
      <b-form-group id="PowerRatio" label="Lv係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.PowerRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
    </b-card>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
const newCode = ()=>{
  return {
    buff: { '@arg':'buff' },
    target: { '@arg':'target' },

    HP:1, Buffer:1000,

    PowerRatio: 0.0,
  }    
}
export default {
  props: {
    value: Object,
    info: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  },
  newCode
}
</script>

<style lang="scss" scoped>

</style>
